import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import styles from '../index.module.css';
import Logo from '../../../assets/images/brand/Uni_logo_landscape_white.png';
import ToggleIcon from '../../../assets/images/icons/toggle_icon.png';
import ExamControllerAssistantRoutes from "../../../routes/ExamControllerAssistantRoutes";

const ExamControllerAssistantSidebar = ({ isSidebarOpen, closeSidebar }) => {
    const location = useLocation(); 
    const slicedRoutes = ExamControllerAssistantRoutes.slice(0, 2);

    useEffect(() => {
        document.addEventListener("mousedown", closeSidebar);
        return () => {
            document.removeEventListener("mousedown", closeSidebar);
        };
    }, []);

    return (
        <>
            <div className={`${styles.sideBarContainer} ${isSidebarOpen ? styles.showSidebar : styles.hideSidebar
                }`}>
                <div className={styles.sidebarLogo}>
                    <img src={ToggleIcon} className={styles.toggleBtn} alt="toggle" onClick={closeSidebar} />
                    <img src={Logo} alt="IBSUniversity" className={styles.logoImage} />
                </div>
                <ul className={styles.sidebarMenu}>
                    {slicedRoutes.map((item, index) => (
                        <li
                            key={index}
                            className={location.pathname === `/assistant/${item.path}` ||
                                location.pathname.startsWith(`/assistant/${item.path}/`) ? styles.active : ""} // Add 'active' class
                        >
                            <Link to={`/assistant/${item.path}`} className={styles.linkText}>
                                <img alt="icon" src={location.pathname === `/assistant/${item.path}` ||
                                    location.pathname.startsWith(`/assistant/${item.path}/`) ? item.icon : item.inactiveIcon}
                                    className={styles.sidebarIcon} />
                                <span>{item.name}</span>
                            </Link>
                        </li>
                    ))}
                </ul>
            </div>
        </>
    );
};

export default ExamControllerAssistantSidebar;